import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-direct-deposit-disclaimer-modal',
  templateUrl: './direct-deposit-disclaimer-modal.component.html',
  styleUrls: ['./direct-deposit-disclaimer-modal.component.css'],
  standalone: false
})
export class DirectDepositDisclaimerModalComponent implements OnInit {
  authorized: boolean = false;

  private modalRef: NgbModalRef;
  @Output('submit')
  public submit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('directDepositDisclaimerModal', { static: true })
  public modalContent: TemplateRef<any>;
  ngOnInit() {
    this.modalRef = this.ngModalService.open(this.modalContent, {
      size: 'lg',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
    this.modalRef.result.then(
      // close
      result => {},
      // dismiss
      () => this.submit.emit(false)
    );
  }

  constructor(private ngModalService: NgbModal) {}

  submitModal() {
    this.submit.emit(this.authorized);
    this.modalRef.close();
  }
}
